import React from 'react';
import { Card, Col, Row, Steps, Typography } from 'antd';
import {
  ApiOutlined,
  CheckCircleOutlined,
  FilterOutlined,
  LinkOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';

const { Paragraph, Text } = Typography;

export const PROGRAM_WIZARD_STEPS = [
  { key: 'basics', title: 'Basics', icon: <SettingOutlined /> },
  { key: 'link', title: 'Link type', icon: <LinkOutlined /> },
  { key: 'eligibility', title: 'Eligibility', icon: <TeamOutlined /> },
  { key: 'rules', title: 'Rules', icon: <FilterOutlined /> },
  { key: 'publish', title: 'Publish', icon: <CheckCircleOutlined /> },
];

export const PROGRAM_TAB_GOALS = {
  basics: 'Name the benefit and set when it is available globally.',
  link: 'Connect this program to an encounter type that runs the clinical workflow.',
  eligibility: 'Who on the employer’s paid roster qualifies — scope, gender, and age narrow the HR report and check-in gate.',
  rules: 'Completion rules, duplicate gates, HR report columns, and status labels.',
  publish: 'Review eligibility summary and publish — orgs can enable it after publish.',
};

export function ProgramWizardNav({ activeKey, onChange, isNew }) {
  const current = PROGRAM_WIZARD_STEPS.findIndex((s) => s.key === activeKey);
  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      {isNew && (
        <Paragraph type="secondary" style={{ marginBottom: 12, fontSize: 13 }}>
          Save <Text strong>Basics</Text> first to create a draft program.
        </Paragraph>
      )}
      <Steps
        size="small"
        current={current < 0 ? 0 : current}
        onChange={(idx) => onChange?.(PROGRAM_WIZARD_STEPS[idx]?.key)}
        items={PROGRAM_WIZARD_STEPS.map((s) => ({ title: s.title, icon: s.icon }))}
        style={{ cursor: 'pointer' }}
      />
    </Card>
  );
}

export function ProgramTabGoal({ tabKey }) {
  const goal = PROGRAM_TAB_GOALS[tabKey];
  if (!goal) return null;
  return <Paragraph strong style={{ marginBottom: 16, fontSize: 15 }}>{goal}</Paragraph>;
}

export function ProgramLiveSummary({ children }) {
  if (!children) return null;
  return (
    <Card size="small" style={{ marginBottom: 16, background: '#f6ffed', borderColor: '#b7eb8f' }}>
      <Text><ApiOutlined style={{ color: '#52c41a', marginRight: 8 }} /></Text>
      <Text strong>Right now: </Text>
      {children}
    </Card>
  );
}

export function ProgramNextHint({ nextTabKey }) {
  const next = PROGRAM_WIZARD_STEPS.find((s) => s.key === nextTabKey);
  if (!next) return null;
  return (
    <Paragraph type="secondary" style={{ fontSize: 13, marginTop: 16, marginBottom: 0 }}>
      Next: <Text strong>{next.title}</Text>
    </Paragraph>
  );
}
